import { render } from "./SearchBar.vue?vue&type=template&id=de5d3248&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=ts"
export * from "./SearchBar.vue?vue&type=script&lang=ts"

import "./SearchBar.vue?vue&type=style&index=0&id=de5d3248&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-de5d3248"

export default script